import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import RoleForm from '@galo-monitor/web-containers/forms/company/RoleForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const RoleModal = (props) => {
  const {
    id,
    open,
    handleClose,
    role,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    () => {
      setLoading(false)
      createDialog({
        id: 'error-role',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(isEmpty(role) ? 'register' : 'update')),
            this: toLower(t('role', { howMany: 1 }))
          })  }.`
        }
      })
    },
    [createDialog, role, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ `${ t('register of {this}', { this: t('role', { howMany: 2 }) }) } Company` }
      maxWidth="xl"
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <RoleForm
        ref={ formRef }
        role={ role }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

RoleModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  role: PropTypes.object
}

RoleModal.defaultProps = {
  role: {}
}

export default RoleModal
